import { render, staticRenderFns } from "./sys_teacherDept.vue?vue&type=template&id=56fc6450&scoped=true"
import script from "./sys_teacherDept.vue?vue&type=script&lang=js"
export * from "./sys_teacherDept.vue?vue&type=script&lang=js"
import style0 from "./sys_teacherDept.vue?vue&type=style&index=0&id=56fc6450&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fc6450",
  null
  
)

export default component.exports